<div
  class="sg-dialog sg-ui-component"
  [class.sg-dialog--vertical]="layout === 'vertical'"
  [class.sg-dialog--horizontal]="layout === 'horizontal'"
  [class.has-dont-show-again-checkbox]="displayDontShowAgainCheckbox"
  mat-dialog-content>
  <div class="sg-dialog__content">
    <div class="sg-dialog__header">
      <div mat-dialog-title class="sg-dialog__header-row">
        @if (icon) {
          <div class="sg-dialog__icon">
            @if (iconType === "material") {
              <mat-icon class="sg-ui-component" [style.color]="'var(' + iconColor + ', ' + iconColor + ')'">{{ icon }}</mat-icon>
            }
            @if (iconType === "image") {
              <img [sgInlineSvg]="assetsPath + icon" />
            }
          </div>
        }
        <div class="sg-dialog__title">
          <div class="sg-dialog__title-content">
            <sg-text
              variant="sg-heading-large-bold"
              color="sg-content-primary"
              [ngClass]="{ 'sg-text-ellipsis': showTitleTooltipOnOverflow }"
              [sgTooltip]="showTitleTooltipOnOverflow ? title : undefined"
              [showOnOverflow]="showTitleTooltipOnOverflow || false"
              [style.display]="showTitleTooltipOnOverflow ? 'block' : null">
              {{ title }}
            </sg-text>
            @if (titleBadges && titleBadges.length > 0) {
              <div class="sg-dialog__title-badges" [class.sg-dialog__title-badges--divided]="titleBadgeDivider">
                @for (badge of titleBadges; track badge) {
                  @if (badge.type === "label") {
                    <sg-label
                      [text]="badge.text"
                      [variant]="badge.variant"
                      [labelSize]="badge.labelSize || 'small'"
                      [inverted]="badge.inverted || false"></sg-label>
                  }
                  @if (badge.type === "status-tag") {
                    <sg-status-tag
                      [status]="badge.statusTag"
                      [text]="badge.text"
                      [size]="badge.statusTagSize || 'small'"
                      [withDot]="badge.withDot || false"></sg-status-tag>
                  }
                }
              </div>
            }
          </div>
        </div>
        @if (showCloseButton) {
          <button class="sg-dialog__close" mat-dialog-close (click)="closeDialog()" aria-label="Close">
            <mat-icon class="sg-ui-component">close</mat-icon>
          </button>
        }
      </div>
    </div>
    <div class="sg-dialog__body hiding-scrollbar">
      @if (description) {
        <div class="sg-dialog__description">
          <sg-text variant="sg-body-medium-regular" color="sg-content-secondary"><span [innerHTML]="description"></span></sg-text>
        </div>
      }
      @if (slotContent) {
        <div class="sg-dialog__slot-content" [class.sg-dialog__slot-content--compact]="compactSlot || data?.compactSlot">
          @if (isTemplateRef(slotContent)) {
            <div class="sg-full-width"><ng-container *ngTemplateOutlet="$any(slotContent)"></ng-container></div>
          } @else {
            <div class="sg-full-width"><ng-container *ngComponentOutlet="$any(slotContent); injector: injector"></ng-container></div>
          }
        </div>
      }
    </div>
    @if (layout === "horizontal" && hasButtons) {
      <div class="sg-dialog__footer">
        @if (displayDontShowAgainCheckbox) {
          <div class="sg-dialog__checkbox-section">
            <sg-checkbox
              [items]="[{ label: 'Don\'t show again', labelColor: 'sg-content-secondary', value: false }]"
              (valueChange)="onDontShowAgainChange($event)"></sg-checkbox>
          </div>
        }
        @if (extraButton) {
          <sg-button
            [text]="extraButton.text"
            [variant]="extraButton.variant || 'ghost-secondary'"
            [size]="extraButton.size || 'medium'"
            [disabled]="extraButton.disabled || false"
            [isLoading]="extraButton.isLoading || false"
            [icon]="extraButton.icon"
            [iconPosition]="extraButton.iconPosition || 'end'"
            (onClick)="onExtraButtonClick()"
            class="sg-dialog__button sg-dialog__button--extra"></sg-button>
        }
        <div class="sg-dialog__buttons">
          @if (cancelButton) {
            <sg-button
              [text]="cancelButton.text"
              [variant]="cancelButton.variant || 'secondary'"
              [size]="cancelButton.size || 'medium'"
              [disabled]="cancelButton.disabled || false"
              [isLoading]="cancelButton.isLoading || false"
              [icon]="cancelButton.icon"
              [iconPosition]="cancelButton.iconPosition || 'end'"
              (onClick)="onCancelButtonClick()"
              class="sg-dialog__button sg-dialog__button--secondary"></sg-button>
          }
          @if (okButton) {
            <sg-button
              [text]="okButton.text"
              [variant]="okButton.variant || 'primary'"
              [size]="okButton.size || 'medium'"
              [disabled]="okButton.disabled || false"
              [isLoading]="okButton.isLoading || false"
              [icon]="okButton.icon"
              [iconPosition]="okButton.iconPosition || 'end'"
              (onClick)="onOkButtonClick()"
              class="sg-dialog__button sg-dialog__button--primary"></sg-button>
          }
        </div>
      </div>
    }
  </div>
  @if (layout === "vertical" && hasButtons) {
    <div class="sg-dialog__footer">
      @if (displayDontShowAgainCheckbox) {
        <div class="sg-dialog__checkbox-section">
          <sg-checkbox
            [items]="[{ label: 'Don\'t show again', labelColor: 'sg-content-secondary', value: false }]"
            (valueChange)="onDontShowAgainChange($event)"></sg-checkbox>
        </div>
      }
      @if (extraButton) {
        <sg-button
          [text]="extraButton.text"
          [variant]="extraButton.variant || 'ghost-secondary'"
          [size]="extraButton.size || 'medium'"
          [disabled]="extraButton.disabled || false"
          [isLoading]="extraButton.isLoading || false"
          [icon]="extraButton.icon"
          [iconPosition]="extraButton.iconPosition || 'end'"
          (onClick)="onExtraButtonClick()"
          class="sg-dialog__button sg-dialog__button--extra"></sg-button>
      }
      <div class="sg-dialog__buttons">
        @if (cancelButton) {
          <sg-button
            [text]="cancelButton.text"
            [variant]="cancelButton.variant || 'secondary'"
            [size]="cancelButton.size || 'medium'"
            [disabled]="cancelButton.disabled || false"
            [isLoading]="cancelButton.isLoading || false"
            [icon]="cancelButton.icon"
            [iconPosition]="cancelButton.iconPosition || 'end'"
            [cssClass]="hasTwoButtons ? 'sg-dialog-full-width-button' : ''"
            (onClick)="onCancelButtonClick()"
            class="sg-dialog__button sg-dialog__button--secondary"></sg-button>
        }
        @if (okButton) {
          <sg-button
            [text]="okButton.text"
            [variant]="okButton.variant || 'primary'"
            [size]="okButton.size || 'medium'"
            [disabled]="okButton.disabled || false"
            [isLoading]="okButton.isLoading || false"
            [icon]="okButton.icon"
            [iconPosition]="okButton.iconPosition || 'end'"
            [cssClass]="hasTwoButtons ? 'sg-dialog-full-width-button' : ''"
            (onClick)="onOkButtonClick()"
            class="sg-dialog__button sg-dialog__button--primary"></sg-button>
        }
      </div>
    </div>
  }
</div>
